import { render, staticRenderFns } from "./VueEmailModal.vue?vue&type=template&id=7f06fde4&scoped=true"
import script from "./VueEmailModal.vue?vue&type=script&lang=js"
export * from "./VueEmailModal.vue?vue&type=script&lang=js"
import style0 from "./VueEmailModal.vue?vue&type=style&index=0&id=7f06fde4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06fde4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f06fde4')) {
      api.createRecord('7f06fde4', component.options)
    } else {
      api.reload('7f06fde4', component.options)
    }
    module.hot.accept("./VueEmailModal.vue?vue&type=template&id=7f06fde4&scoped=true", function () {
      api.rerender('7f06fde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueEmail/VueEmailModal.vue"
export default component.exports